"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigPropField = void 0;
var ConfigPropField;
(function (ConfigPropField) {
    ConfigPropField["DIMMABLE"] = "dimmable";
    ConfigPropField["HAS_LID"] = "hasLid";
    ConfigPropField["FAN_INTERNAL_ID"] = "fanIid";
    ConfigPropField["LID_OPEN_INTERNAL_ID"] = "lidOpenIid";
    ConfigPropField["LID_CLOSE_INTERNAL_ID"] = "lidCloseIid";
    ConfigPropField["CAPACITY"] = "capacity";
    ConfigPropField["HAS_HEATER"] = "hasHeater";
    ConfigPropField["HAS_PUMP"] = "hasPump";
    ConfigPropField["HEATER_INTERNAL_ID"] = "heaterIid";
    ConfigPropField["PUMP_INTERNAL_ID"] = "pumpIid";
    ConfigPropField["HAS_DISCONNECT"] = "hasDisconnect";
    ConfigPropField["DISCONNECT_INTERNAL_ID"] = "disconnectIid";
    ConfigPropField["AXLE"] = "axle";
    ConfigPropField["POSITION"] = "position";
    ConfigPropField["IS_SPARE"] = "isSpare";
    ConfigPropField["LOW_PRESSURE_LIMIT"] = "lowPressure";
    ConfigPropField["VERY_LOW_PRESSURE_LIMIT"] = "veryLowPressure";
    ConfigPropField["HI_PRESSURE_LIMIT"] = "highPressure";
    ConfigPropField["HI_TEMP_LIMIT"] = "highTemp";
    ConfigPropField["SHADE_INTERNAL_ID"] = "shadeIid";
    ConfigPropField["FAN_SPEEDS"] = "fanSpeeds";
    ConfigPropField["MIN_TEMPERATURE"] = "minTemperature";
    ConfigPropField["MAX_TEMPERATURE"] = "maxTemperature";
    ConfigPropField["MODE_INTERNAL_ID"] = "modeIid";
    ConfigPropField["FAN_SPEED_INTERNAL_ID"] = "fanSpeedIid";
    ConfigPropField["SET_TEMP_INTERNAL_ID"] = "setTempIid";
    ConfigPropField["MODES"] = "modes";
    ConfigPropField["CAN_LOCK"] = "canLock";
    ConfigPropField["HAS_LIGHT"] = "hasLight";
    ConfigPropField["LIGHT_INTERNAL_ID"] = "lightIid";
    ConfigPropField["LOCKED_INTERNAL_ID"] = "lockedIid";
    ConfigPropField["UNLOCKED_INTERNAL_ID"] = "unlockedIid";
    ConfigPropField["OPEN_INTERNAL_ID"] = "openIid";
    ConfigPropField["CLOSE_INTERNAL_ID"] = "closeIid";
    ConfigPropField["CLOSED_INTERNAL_ID"] = "closedIid";
    ConfigPropField["OPENED_INTERNAL_ID"] = "openedIid";
    ConfigPropField["MOVING_INTERNAL_ID"] = "movingIid";
    ConfigPropField["OPEN_ON_INTERNAL_ID"] = "openOnIid";
    ConfigPropField["CLOSE_OFF_INTERNAL_ID"] = "closeOffIid";
    ConfigPropField["SPEED_COMMAND_INTERNAL_ID"] = "speedCommandIid";
    ConfigPropField["TILT_LEFT_INTERNAL_ID"] = "tiltLeftIid";
    ConfigPropField["TILT_RIGHT_INTERNAL_ID"] = "tiltRightIid";
    ConfigPropField["LEGACY_LID_CONTROL"] = "isLegacyLidControl";
    ConfigPropField["SKYLIGHT_INTERNAL_ID"] = "skylightIid";
})(ConfigPropField = exports.ConfigPropField || (exports.ConfigPropField = {}));
//# sourceMappingURL=ConfigPropField.js.map